module.exports = __webpack_public_path__ + "static/media/recomendation.bd891d4f.png";